import { Reveal } from "./Reveal";
import { FAQS } from "../data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32 bg-[#EAE3D9]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.25em] font-bold text-[#C85A40] mb-4 text-center">Good to know</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight text-[#1A1714] text-center mb-16">
            Questions, answered honestly
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#C85A40]/25">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-xl md:text-2xl tracking-tight text-[#1A1714] hover:text-[#C85A40] hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A453F] text-base leading-relaxed pb-6 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
